import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const MasterModalShell = ({
  open,
  onClose,
  isUpdate,
  entityLabel,
  saving,
  loading,
  validationError,
  onSubmit,
  maxWidth = "sm",
  children,
}) => (
  <Dialog
    open={open}
    onClose={() => !saving && onClose("close")}
    fullWidth
    maxWidth={maxWidth}
  >
    <DialogTitle sx={{ fontWeight: 600 }}>
      {isUpdate ? `Edit ${entityLabel}` : `Add ${entityLabel}`}
    </DialogTitle>

    <DialogContent dividers>
      {loading ?
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      : <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 1 }}>
          {children}

          {validationError && (
            <Box sx={{ color: "#d32f2f", fontSize: "0.8rem" }}>
              {validationError}
            </Box>
          )}
        </Box>
      }
    </DialogContent>

    <DialogActions sx={{ padding: "1rem 1.5rem" }}>
      <Button onClick={() => onClose("close")} disabled={saving}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={saving || loading || Boolean(validationError)}
        sx={{ bgcolor: "#194AF5", ":hover": { bgcolor: "#1540d6" } }}
      >
        {saving ?
          <CircularProgress size="1.2rem" sx={{ color: "#fff" }} />
        : "Save"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default MasterModalShell;
